import { ArrowRight } from '@components/icons'
import { envVar } from '@env'
import { loggedOutPricing, loginRoute } from '~/features/routes'
import { Button } from '@st/theme'
import { HeaderNavigation } from '@theme'
import { ReactNode } from 'react'
import { useProcess } from '~/store'
import { routeModule } from '~/features/route-module'

export function OrganizationMarketingHeader() {
  const route = useProcess('route')

  function onClickLogin() {
    route.send({ type: 'navigate', pathname: loginRoute({}) })
  }

  return (
    <HeaderNavigation backHref={envVar('NEXT_PUBLIC_HOMEPAGE_URL') ?? '/'}>
      <Button variant="subtle" href={loggedOutPricing({})}>
        Plans
      </Button>

      <Button className="login" variant="subtle" onClick={onClickLogin}>
        Log In
      </Button>

      <GetStartedButton>Try for free</GetStartedButton>
    </HeaderNavigation>
  )
}

function GetStartedButton({ children }: { children: ReactNode }) {
  const route = useProcess('route')

  function onClick() {
    route.send({ type: 'getStarted' })
  }

  return (
    <Button variant="subtle" onClick={onClick} trailingIcon={<ArrowRight />}>
      {children}
    </Button>
  )
}
